// export const SUBSCRIPTION_PLANS = [
//   {
//     key: "starter",
//     name: "Starter",
//     price: 0,
//     tagline: "Cocok untuk promosi usaha kost yang baru mulai",
//     // badge: "Popular",
//     features: [
//       { name: "Property Landing Page for Marketing", included: true },
//       { name: "Online Marketing and SEO by Superkos", included: true },
//       // { name: "Limited Properties", included: false },
//       // { name: "Property & Setting Access", included: true },
//       // { name: "Setting Access", included: true },
//     ],
//     cta: "Select Starter",
//   },
//   {
//     key: "standard",
//     name: "Standard",
//     price: 6000,
//     tagline: "",
//     badge: "Popular",
//     features: [
//       { name: "Property Landing Page for Marketing", included: true },
//       { name: "Online Marketing and SEO by Superkos", included: true },
//       { name: "Dashboard for Analytic ", included: true },
//       { name: "Property Management", included: true },
//       { name: "Room Management", included: true },
//       { name: "Tenant Management", included: true },
//       { name: "Automated Reminders", included: true },
//       { name: "24/7 Live Support by WhatsApp", included: true },
//     ],
//     cta: "Select Standard",
//   },
//   {
//     key: "premium",
//     name: "Premium",
//     price: 8000,
//     tagline: "",
//     // badge: "Popular",
//     features: [
//       { name: "Property Landing Page for Marketing", included: true },
//       { name: "Online Marketing and SEO by Superkos", included: true },
//       { name: "Dashboard for Analytic ", included: true },
//       { name: "Property Management", included: true },
//       { name: "Room Management", included: true },
//       { name: "Tenant Management", included: true },
//       { name: "Automated Reminders", included: true },
//       { name: "24/7 Live Support by WhatsApp", included: true },
//     ],
//     cta: "Select Premium",
//   },
// ];

export const SUBSCRIPTION_PLANS = [
  {
    key: "starter",
    name: "Starter",
    price: 0,
    tagline: "Start promoting your room for rent online",
    features: [
      { name: "Marketing Page", included: true },
      { name: "SEO & Promotion", included: true },
      { name: "Multi-Property Management", included: true },
      { name: "Basic Support", included: true },
      // { name: "Room Management", included: false },
      // { name: "Tenant Management", included: false },
      // { name: "Analytics & Reports", included: false },
      // { name: "Automated Reminders", included: false },
    ],
    cta: "Start Free",
  },
  {
    key: "standard",
    name: "Standard",
    price: 6000,
    tagline: "Manage your boarding house operations more efficiently",
    badge: "Popular",
    features: [
      { name: "Everything in Starter", included: true },
      // { name: "Marketing Page", included: true },
      // { name: "SEO & Promotion", included: true },
      // { name: "Multi-Property Management", included: true },
      // { name: "Basic Support", included: true },
      { name: "Room Management", included: true },
      { name: "Tenant Management", included: true },
      { name: "Analytics & Reports", included: true },
      { name: "Automated Reminders", included: true },
      // { name: "Chat Feature", included: false },
      // { name: "Repeated Reminders", included: false },
      // { name: "Custom Template Reminders ", included: false },
      // { name: "Priority Support", included: false },
      // { name: "Whatsapp Support", included: false },
    ],
    cta: "Choose Growth",
  },
  {
    key: "premium",
    name: "Premium",
    price: 8000,
    tagline: "Optimize your boarding house business with automation and insights",
    features: [
      // { name: "Marketing Page", included: true },
      // { name: "SEO & Promotion", included: true },
      // { name: "Multi-Property Management", included: true },
      // { name: "Room Management", included: true },
      // { name: "Tenant Management", included: true },
      // { name: "Analytics & Reports", included: true },
      // { name: "Automated Reminders", included: true },
      { name: "Everything in Standard", included: true },
      { name: "Chat Feature", included: true },
      { name: "Repeated Reminders", included: true },
      { name: "Custom Template Reminders", included: true },
      // { name: "Custom Branding", included: true },
      // { name: "Tenant Payment Tracking", included: true },
      // { name: "Performance Insights (AI-based)", included: true },
      { name: "Priority Support", included: true },
      // { name: "Whatsapp Support", included: true },
    ],
    cta: "Go Pro",
  },
];

export const SUBSCRIPTION_STATUS = {
  ACTIVE: "active",
  PENDING: "pending",
  CANCELLED: "cancelled",
  EXPIRED: "expired",
};

export const SUBSCRIPTION_CHANGE_TYPE = {
  upgrade: "Upgrade",
  upsize: "Upsize",
  downgrade: "Downgrade",
  downsize: "Downsize",
  term_change: "Term Change",
  renewal: "Renewal",
};

export const SUBSCRIPTION_CHANGE_STATUS = {
  pending_payment: "Pending Change",
  scheduled: "Scheduled Change",
  completed: "Completed Change",
  cancelled: "Cancelled Change",
  failed: "Failed Change",
};
